import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import LogoSpinner from "../LogoSpinner/LogoSpinner";
import { capitalize } from "../../../utils/helpers";

const useStyles = makeStyles(theme => ({
  alignLeft: {
    textAlign: 'left',
  },
  alignCenter: {
    textAlign: 'center',
  },
  alignRight: {
    textAlign: 'right',
  },
  sizeTiny: {
    height: '16px',
  },
  sizeSmall: {
    height: '24px',
  },
  sizeNormal: {
    height: '32px'
  },
  sizeLarge: {
    height: '50px',
  },
  diplayBlock: {
    display: 'block',
  },
  diplayInlint: {
    display: 'inline',
  },
}));

const InlineSpinner = props => {
  const {
    size = "normal",
    align = "inherit",
    display = "initial",
    animation = 'heartbeat',
    className,
    ...other
  } = props;
  const classes = useStyles();
  return (
    <div className={clsx({
      [classes[`display${capitalize(display)}`]]: display !== 'initial',
      [classes[`align${capitalize(align)}`]]: align !== 'inherit',
    },
    className)}>
      <LogoSpinner animation={animation} className={clsx({
        [classes[`size${capitalize(size)}`]]: size !== "inherit",
      })} {...other} />
    </div>
  );
};

InlineSpinner.propTypes = {
  size: PropTypes.oneOf(["inherit", "tiny", "small", "normal", "large"]),
  align: PropTypes.oneOf(["inherit", "left", "center", "right"]),
  display: PropTypes.oneOf(["initial", "block", "inline"]),
  clasName: PropTypes.string,
};

export default InlineSpinner;
